import { FormattedUnitData, UnitListFilters } from "~/types";
import * as APITypes from "~/API";

export const getFilteredUnitList = ({
  filters,
  unitList,
  isAdminOrSuperAdmin,
}: {
  filters: UnitListFilters;
  unitList: FormattedUnitData[];
  isAdminOrSuperAdmin: boolean;
}): FormattedUnitData[] => {
  let filteredList = unitList;

  // Filter by user search criteria
  if (filters.status) {
    filteredList = filteredList.filter((unitData) => {
      return unitData.unitDetails.status === filters.status;
    });
  }

  if (filters.numBedroom) {
    const baseNumber = Number(filters.numBedroom.split("+")[0]);
    filteredList = filteredList.filter((unitData) => {
      return Number(unitData.unitDetails.numBedroom) >= baseNumber;
    });
  }

  if (filters.numBathroom) {
    const baseNumber = Number(filters.numBathroom.split("+")[0]);
    filteredList = filteredList.filter((unitData) => {
      return Number(unitData.unitDetails.numBathroom) >= baseNumber;
    });
  }

  if (filters.propertyId) {
    filteredList = filteredList.filter((unitData) => {
      return unitData.propertyDetails.id === filters.propertyId;
    });
  }

  // Filter by access rights (only if not admin/superadmin)
  if (!isAdminOrSuperAdmin) {
    filteredList = filteredList.filter((unitData) => {
      return (
        unitData.accessRights?.readAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted ||
        unitData.accessRights?.writeAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted
      );
    });
  }

  return filteredList;
};
